import ReactDOM from 'react-dom/client';
import "./styles/theme.css";
import './styles/index.css';
import './styles/modal.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './providers/AuthContext';
import { BrowserRouter } from 'react-router-dom';
import { UIProvider } from './providers/MoleUIContext';
import { SnackbarProvider } from 'notistack';
import { AppSocketProvider } from './providers/AppSocketContext';
import { AppThemeProvider } from './providers/ThemeProvider';
import { HelmetProvider } from 'react-helmet-async';
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import "./i18n"; 

const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement
);

root.render(
	<AppSocketProvider>
		<BrowserRouter>
			<AuthProvider>
				<AppThemeProvider>
					<UIProvider>
						<SnackbarProvider maxSnack={3}>
							{/* <StrictMode> */}
							<HelmetProvider>
								<App />
							</HelmetProvider>
							{/* </StrictMode> */}
						</SnackbarProvider>
					</UIProvider>
				</AppThemeProvider>
			</AuthProvider>
		</BrowserRouter >
	</AppSocketProvider>
);


serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
